import {
    useCallback,
} from 'react'
import Grid from '@mui/material/Grid'

import AdvancedList, {
    ListColumn,
} from 'app/shared-components/AdvancedList/AdvancedList'
import useEnumValues from 'app/hooks/useEnumValues'
import Select from 'app/shared-components/Select/SelectContainer'
import InputSingleline from 'app/shared-components/InputSingleline'

import {
    ContainerAvailabilityAllowedProductTypes,
} from 'app/enums/label.enums'
import {
    ContainerProductionRateType,
} from '../../serviceCenters.types'
import useStyles from './containerProductionRate.style'

const columns: ListColumn[] = [
    {
        colSpan: 8,
        label: 'Type',
    },
    {
        colSpan: 'grow',
        label: 'Daily Rate',
    },
]

const defaultProps = {
    disabled: false,
    required: false,
    exists: false,
}

const ContainerProductionRate = ({
    value,
    onChange,
    disabled,
    required,
    exists,
}: {
    value: ContainerProductionRateType[],
    onChange: (val: ContainerProductionRateType) => void,
    disabled?: boolean,
    required?: boolean,
    exists?: boolean,
}) => {
    const {
        classes,
    } = useStyles()
    const allowedValues = useEnumValues()(
        Object.fromEntries(
            Object.entries(ContainerAvailabilityAllowedProductTypes).filter(([key]) => { return !key.includes('CRT') }),
        ),
    )

    const onItemCellChange = useCallback(({
        item, newValue, index, handleChange,
    }) => {
        const newItem = {
            ...item,
            ...newValue,
        }

        handleChange(newItem, index)
    }, [])

    const validateItemForAdd = useCallback((item: ContainerProductionRateType): boolean => {
        return item?.dailyRate > 0
            && Boolean(item?.productType)
    }, [])

    const renderItem = useCallback(({
        index,
        item,
        handleChange,
    }) => {
        return (
            <>
                <Grid
                    key={`row-container-${index}`}
                    size={columns[0].colSpan}
                    p={1}
                >
                    <Select
                        name="containerType"
                        allowedValues={allowedValues}
                        value={item?.productType}
                        onChange={(newValue) => {
                            return onItemCellChange({
                                newValue: {
                                    productType: newValue,
                                },
                                index,
                                item,
                                handleChange,
                            })
                        }}
                        required={required}
                        disabled={disabled}
                    />
                </Grid>
                <Grid
                    key={`row-dailyRate-${index}`}
                    size={columns[1].colSpan}
                    p={1}
                >
                    <InputSingleline
                        name="dailyRate"
                        type="number"
                        min={1}
                        centerAligned
                        onChange={(newValue) => {
                            return onItemCellChange({
                                index,
                                item,
                                handleChange,
                                newValue: {
                                    dailyRate: Number(newValue),
                                },
                            })
                        }}
                        className={classes.input}
                        value={item?.dailyRate}
                        required={required}
                        disabled={disabled}
                    />
                </Grid>
            </>
        )
    }, [
        allowedValues,
        required,
        disabled,
        classes.input,
        onItemCellChange,
    ])

    if (exists) {
        return (
            <>
                {value && (
                    <AdvancedList<ContainerProductionRateType>
                        onChange={onChange}
                        disabled={disabled}
                        value={value}
                        renderItem={renderItem}
                        addButtonLabel="new container"
                        columns={columns}
                        validateForAdd={validateItemForAdd}
                    />
                )}
            </>
        )
    }

    return (
        <AdvancedList<ContainerProductionRateType>
            onChange={onChange}
            disabled={disabled}
            value={value}
            renderItem={renderItem}
            addButtonLabel="new container"
            columns={columns}
            validateForAdd={validateItemForAdd}
        />
    )
}

ContainerProductionRate.defaultProps = defaultProps

export default ContainerProductionRate
